<template>
  <input
    v-model="Value"
    v-mask="vMask"
    class="uk-input uk-width-1-1"
    :type="type"
    :min="min"
    :max="max"
    :maxlength="maxlength"
    :class="[{'uk-form-danger': isError}, Class]"
    :pattern="regExp"
    :autocomplete="autocomplete ? 'on' : 'off'"
    @input="Input"
    @change="Change"
    @keyup="KeyUp"
    @keydown="KeyDown"
    @keypress="Keypress"
    @focus="formattedValue($event)"
    @blur="formattedValue($event)"
  />
</template>

<script>
let BaseClass = 'uk-form'
let InputSize = {
  Small: '-small',
  Large: BaseClass + '-large'
}
export default {
  name: 'b-input',
  props: {
    type: {
      type: String,
      default: 'Text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    max: {
      type: [String, Number],
      default: 100
    },
    maxlength: {
      type: [String, Number],
      default: 100
    },
    min: {
      type: [String, Number],
      default: 1
    },
    size: {
      type: String,
      default: 'Large'
    },
    name: {
      type: String,
      default: ''
    },
    isError: {
      type: [Boolean],
      default: false
    },
    regExp: {
      type: String,
      default: undefined
    },
    upper: {
      type: Boolean,
      default: false
    },
    mask: {
      type: String,
      default: null
    },
    autocomplete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Value: this.value,
      vMask: ''
    }
  },
  computed: {
    Class() {
      return [this.Size]
    },
    Size() {
      return InputSize[this.size]
    }
  },
  methods: {
    Input() {
      if (this.upper) {
        this.$emit('input', this.Value.toUpperCase())
      } else {
        this.$emit('input', this.Value)
      }
    },
    Change() {
      this.$emit('change', this.Value)
    },
    KeyUp() {
      this.$emit('keyup', this.Value)
    },
    KeyDown() {
      this.$emit('keydown', this.Value)
    },
    formattedValue(event) {
      if (this.mask === 'phone') {
        if (event.type === 'focus' && !event.target.value) {
          event.target.value = '+375 ('
        }

        if (event.type === 'blur' && event.target.value === '+375 (') {
          event.target.value = ''
        }
      }

      if (this.mask === 'passport') {
        if (event.type === 'focus' && !event.target.value) {
          event.target.placeholder = 'RR1111111'
        }

        if (event.type === 'blur' && !event.target.value) {
          event.target.placeholder = ' '
        }
      }
    },
    Keypress(event) {
      this.$emit('keypress', event)
    },
    checkMask() {
      if (this.mask === 'phone') {
        this.vMask = '+### (##) ### ####'
      }

      if (this.mask === 'passport') {
        this.vMask = 'AA#######'
      }
    }
  },
  mounted() {
    this.checkMask()
  },
  watch: {
    value(value) {
      this.Value = value
      this.value = value
    }
  }
}
</script>

<style scoped lang="scss">
.uk-input {
  padding: 12px 26px;
  font-family: inherit;
  font-weight: 500;
  font-size: 1.01rem;
  border-radius: 10px;
  line-height: 1;
  font-kerning: normal;
  letter-spacing: 0.01rem;

  &::placeholder {
    opacity: 0.5;
  }
}

.uk-form-large {
  height: 50px !important;
}

.uk-input.upper-text {
  text-transform: uppercase;
}
</style>
